import { render } from '@wordpress/element';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/style.scss';

const appEl = document.getElementById('bajantube-crop-over-app');

if (appEl) {
    const basePath = appEl.dataset.basePath || '/cropover';

    render(
        <BrowserRouter basename={basePath}>
            <App />
        </BrowserRouter>,
        appEl
    );
}